function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.1",
  id: "Ebene_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  viewBox: "0 0 283.5 283.5",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Road"
}, /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M226.8 28.3H56.7L0 248h283.5L226.8 28.3zm-99.3 155.9v35.4H36.6l42.1-163h48.9V92h28.3V56.7h48.9l42.1 163h-91v-35.4h-28.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M127.6 120.5h28.3v35.4h-28.3z"
}))));